import Route from '@ember/routing/route';
import type RouterService from '@ember/routing/router-service';
import type Transition from '@ember/routing/transition';
import { service } from '@ember/service';
import type AbilitiesService from 'ember-can/services/abilities';
import { isProductDisabled } from 'garaje/helpers/product-disabled';
import type CurrentAdminService from 'garaje/services/current-admin';
import type FeatureFlagsService from 'garaje/services/feature-flags';
import type MetricsService from 'garaje/services/metrics';
import type StateService from 'garaje/services/state';
import type UserFeatureFlagsService from 'garaje/services/user-feature-flags';
import { AnalyticsEventNames } from 'garaje/utils/enums';

import type GlobalAnalyticsVisitorsController from './controller';

export default class GlobalAnalyticsVisitorsDashboardRoute extends Route {
  @service declare abilities: AbilitiesService;
  @service declare router: RouterService;
  @service declare featureFlags: FeatureFlagsService;
  @service declare userFeatureFlags: UserFeatureFlagsService;
  @service declare state: StateService;
  @service declare currentAdmin: CurrentAdminService;
  @service declare metrics: MetricsService;

  beforeModel(): void {
    const { vrSubscription } = this.state;
    if (this.abilities.cannot('visit-visitors global-analytics') || !vrSubscription?.canAccessGlobalAnalytics) {
      this.router.transitionTo('unauthorized');
    }
  }

  afterModel(): void {
    this.#logMetrics();
  }

  setupController(controller: GlobalAnalyticsVisitorsController, model: void, transition: Transition): void {
    super.setupController(controller, model, transition);
    controller.showModal = false;

    if (
      (this.featureFlags.isEnabled('sigma-embedded-analytics') ||
        this.userFeatureFlags.isEnabled('sigma-embedded-analytics-by-user')) &&
      !isProductDisabled('analytics-v2')
    ) {
      void controller.fetchSigmaUrlTask.perform();
    }
  }

  #logMetrics(): void {
    const companyId = this.state?.currentCompany?.id;
    const details = {
      companyId,
      app: this.state.vrSubscription?.app,
      plan: this.state?.vrSubscription?.plan,
      userId: this.currentAdmin?.id || '',
      employeeId: this.currentAdmin.employee?.id || '',
    };
    this.metrics.trackEvent(AnalyticsEventNames.VISITORS_GLOBAL_DASHBOARD_VISITED, details);
    this.metrics.logMonitorEvent(AnalyticsEventNames.VISITORS_GLOBAL_DASHBOARD_VISITED, details);
  }
}
